import { gql } from '@apollo/client';

export const SigninWithZzimTokenMutation = gql`
  mutation SigninWithZzimToken($accessToken: String!, $refreshToken: String) {
    signinWithZzimToken(accessToken: $accessToken, refreshToken: $refreshToken) {
      status
      accessToken
      pointAmount
      profileImgUrl
      user {
        id
        email
        name
        nickname
        isLocationTermsAgreed
        FTUERecords {
          code
        }
      }
      zzimAccessToken
      zzimRefreshToken
    }
  }
`;

export const TripCurationsQuery = gql`
  query TripCurations {
    tripCurations {
      title
      trips {
        id
        customName
        companion {
          name
        }
        cities {
          id
          name
          country
          mainImageUrl(width: 440, height: 440)
        }
        fromDateTime
        toDateTime
      }
    }
  }
`;

export const recentlyOpenedSurveysQuery = gql`
  query getRecentlyOpendSurveys {
    recentlyOpenedSurveys {
      id
      cities {
        name
        mainImageUrl(width: 140, height: 140)
        zone {
          id
        }
      }
      companion {
        name
      }
      fromDateTime
      toDateTime
      customName
    }
  }
`;

export const GetExplorePoisQuery = gql`
  query GetExplorePois($zoneIds: [ID!]!, $first: Int!, $after: ID, $companionName: String) {
    explorePois(zoneIds: $zoneIds, first: $first, after: $after, companionName: $companionName) {
      edges {
        cursorId
        node {
          id
          name
          placeId
          images {
            imageUrl(width: 436, height: 436)
            sourceUrl
          }
          city {
            name
            zone {
              id
              name
            }
          }
          saved
          banned
          poiType
          categories
          mainTag
        }
      }
      pageInfo {
        hasNextPage
        endCursorId
      }
      explorePoisQueryInfo {
        title
        zoneIds
      }
    }
  }
`;

export const TogglePoiSaveSimpleMutation = gql`
  mutation TogglePoiSaveSimple($id: ID, $placeId: String) {
    togglePoiSave(id: $id, placeId: $placeId) {
      id
      placeId
      name
      originName
      poiType
      saved
      banned
      latitude
      longitude
    }
  }
`;

export const GetPoiDetailQuery = gql`
  query GetPoiDetail($id: ID!) {
    poi(id: $id) {
      id
      name
      poiType
      categories
      placeId
      city {
        zone {
          id
          name
        }
      }
      ratings {
        provider
        rating
        count
        url
      }
      articles {
        source
        title
        url
      }
      tags
      address
      latitude
      longitude
      phone
      websiteUrl
      openHours
      amenities {
        imageUrl
        name
      }
      ranking {
        text
        createdAt
      }
      priceRange
      priceLevel
      saved
      banned
      menu {
        name
        price
      }
      gptDescription
      grade
      images {
        imageUrl
        sourceUrl
      }
      businessStatus
    }
    reviews(poiId: $id, after: null, first: null) {
      endId
      hasNextPage
      reviews {
        provider
        authorName
        authorUrl
        profilePhotoUrl
        rating
        text
        createdAt
        tripType
        title
        id
        updatedAt
        isLiked
        highlightChips
        spentTimeRange
        priceRange
        userId
        userNickname
        userName
      }
    }
  }
`;

export const GetSavedPoisQuery = gql`
  query GetSavedPois($first: Int!, $after: ID) {
    savedPois(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursorId
      }
      edges {
        cursorId
        node {
          id
          name
          placeId
          images {
            imageUrl(width: 320, height: 320)
            sourceUrl
          }
          city {
            name
            zone {
              id
              name
            }
          }
          saved
          banned
          poiType
          categories
        }
      }
    }
  }
`;

export const GetOwnSurveysQuery = gql`
  query GetOwnSurveys($offset: Int!, $limit: Int!) {
    ownSurveys(offset: $offset, limit: $limit) {
      edges {
        cursorId
        node {
          id
          cities {
            id
            name
            country
            mainImageUrl(width: 440, height: 440)
          }
          companion {
            name
          }
          fromDateTime
          toDateTime
          createdAt
          status
          customName
          itinerary {
            id
            destinations {
              day
              pos
              accommType
            }
          }
          note {
            content
          }
          isOwn
          isCoEdit
          isCoSurvey
        }
      }
      pageInfo {
        hasNextPage
        endCursorId
        offset
        limit
      }
    }
  }
`;

export const GetUpcomingSurveysByPoiIdQuery = gql`
  query GetUpcomingSurveysByPoiId($poiId: ID!, $offset: Int!, $limit: Int!) {
    upcomingSurveysByPoi(poiId: $poiId, offset: $offset, limit: $limit) {
      edges {
        cursorId
        node {
          id
          cities {
            id
            name
            country
            mainImageUrl(width: 440, height: 440)
          }
          companion {
            name
          }
          fromDateTime
          toDateTime
          createdAt
          status
          customName
          itinerary {
            id
            destinations {
              day
              pos
              accommType
            }
          }
          note {
            content
          }
          isOwn
          isCoEdit
          isCoSurvey
        }
      }
      pageInfo {
        hasNextPage
        endCursorId
        offset
        limit
      }
    }
  }
`;

export const GetHolidaysQuery = gql`
  query GetHolidays($start: Date!, $end: Date!) {
    holidays(start: $start, end: $end) {
      date
      name
    }
  }
`;

export const GetFeaturedZonesQuery = gql`
  query GetFeaturedZones($selectedZoneIds: [ID!]) {
    featuredZones(selectedZoneIds: $selectedZoneIds) {
      togetherZones {
        id
        name
        level
        isActive
        levelName
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
          zone {
            id
            name
            level
            isActive
            levelName
            city {
              id
              name
              mainImageUrl(width: 48, height: 48)
            }
          }
        }
        centerCoords
      }
      recentZones {
        id
        name
        level
        isActive
        levelName
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
          zone {
            id
            name
            level
            isActive
            levelName
            city {
              id
              name
              mainImageUrl(width: 48, height: 48)
            }
          }
        }
        centerCoords
      }
      koreaZones {
        id
        name
        level
        isActive
        levelName
        centerCoords
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
        }
      }
      japanZones {
        id
        name
        level
        isActive
        levelName
        centerCoords
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
        }
      }
      southeastAsiaZones {
        id
        name
        level
        isActive
        levelName
        centerCoords
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
        }
      }
      europeZones {
        id
        name
        level
        isActive
        levelName
        centerCoords
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
        }
      }
      americaZones {
        id
        name
        level
        isActive
        levelName
        centerCoords
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
        }
      }
      oceaniaZones {
        id
        name
        level
        isActive
        levelName
        centerCoords
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
        }
      }
      eastAsiaZones {
        id
        name
        level
        isActive
        levelName
        centerCoords
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
        }
      }
      randomFeaturedZones {
        id
        name
        level
        isActive
        levelName
        centerCoords
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
        }
      }
    }
  }
`;

export const GetSavedPoisBySelectedZoneIdsQuery = gql`
  query GetSavedPoisBySelectedZoneIds($selectedZoneIds: [ID!]!, $after: ID, $first: Int!) {
    savedPoisBySelectedZoneIds(selectedZoneIds: $selectedZoneIds, after: $after, first: $first) {
      pageInfo {
        hasNextPage
        endCursorId
      }
      edges {
        cursorId
        node {
          name
          address
          placeId
          poiType
        }
      }
    }
  }
`;

export const SearchPoisAndZonesQuery = gql`
  query SearchPoisAndZones($query: String!, $center: CoordinatesInput) {
    searchZones(query: $query) {
      id
      name
      level
      isActive
      levelName
      city {
        id
        name
        mainImageUrl(width: 48, height: 48)
        zone {
          id
          name
          level
          isActive
          levelName
          city {
            id
            name
            mainImageUrl(width: 48, height: 48)
          }
        }
      }
      centerCoords
    }
    searchPoi(query: $query, center: $center) {
      name
      address
      placeId
      poiType
      poi {
        id
      }
      zones {
        id
        name
        level
        isActive
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
          zone {
            id
            name
            level
            isActive
            city {
              id
              name
              mainImageUrl(width: 48, height: 48)
            }
          }
        }
        centerCoords
      }
    }
  }
`;

export const GetPoiDetailByPlaceIdQuery = gql`
  query GetPoiDetailByPlaceId($placeId: String!) {
    poiByPlaceId(placeId: $placeId) {
      id
      name
      poiType
      categories
      placeId
      city {
        zone {
          id
          name
        }
      }
      ratings {
        provider
        rating
        count
        url
      }
      articles {
        source
        title
        url
      }
      tags
      address
      latitude
      longitude
      phone
      websiteUrl
      openHours
      amenities {
        imageUrl
        name
      }
      ranking {
        text
        createdAt
      }
      priceRange
      priceLevel
      saved
      banned
      menu {
        name
        price
      }
      gptDescription
      grade
      images {
        imageUrl
        sourceUrl
      }
      businessStatus
    }
  }
`;

export const GetPoiReviewsByPoiIdQuery = gql`
  query GetPoiDetail($id: ID!) {
    reviews(poiId: $id, after: null, first: null) {
      endId
      hasNextPage
      reviews {
        provider
        authorName
        authorUrl
        profilePhotoUrl
        rating
        text
        createdAt
        tripType
        title
        id
        updatedAt
        isLiked
        highlightChips
        spentTimeRange
        priceRange
        userId
        userNickname
        userName
      }
    }
  }
`;

export const GetPoiImagesByPlaceIdQuery = gql`
  query GetPoiImagesByPlaceId($placeId: String!) {
    poiByPlaceId(placeId: $placeId) {
      id
      images {
        imageUrl
        sourceUrl
      }
    }
  }
`;

export const WorldcupZonesQuery = gql`
  query WorldcupZones {
    worldcupZones {
      id
      name
      level
      description
      worldcupWinningRate
      landmarkPois {
        id
        placeId
        originName
        name
        poiType
        categories
        gptDescription
        images {
          imageUrl(width: 436, height: 436)
          sourceUrl
        }
      }
      city {
        name
        country
        mainImageUrl(width: 480, height: 480)
      }
    }
  }
`;

export const StartWorldcupMutation = gql`
  mutation startWorldcup($guestUuid: String) {
    startWorldcup(guestUuid: $guestUuid)
  }
`;

export const RecordWorldcupMatchMutation = gql`
  mutation recordWorldcupMatch($input: WorldcupMatchInput!) {
    recordWorldcupMatch(input: $input)
  }
`;

export const GetFaqsQuery = gql`
  query GetFaqs {
    faqs {
      id
      question
      answer
      category
    }
  }
`;

export const CreateReportMutation = gql`
  mutation CreateReport($input: ReportInput!) {
    createReport(reportInput: $input)
  }
`;

export const GetDeparturePoisQuery = gql`
  query GetDeparturePois($center: CoordinatesInput, $destinationZoneIDs: [ID!]!) {
    departurePois(center: $center, destinationZoneIDs: $destinationZoneIDs) {
      name
      address
      poiType
      latitude
      longitude
    }
  }
`;

export const SearchDeparturePoisQuery = gql`
  query GetDeparturePoi($query: String!) {
    searchPoi(query: $query, includePolitical: true) {
      name
      address
      city {
        id
        name
        zone {
          name
          level
        }
      }
      zones {
        id
        name
        level
        city {
          name
        }
      }
      redactedAddress
      latitude
      longitude
    }
  }
`;

export const CreateSurveyMutation = gql`
  mutation CreateSurvey($input: SurveyInput) {
    createSurvey(input: $input) {
      id
    }
  }
`;

export const GetTripQuery = gql`
  query GetTrip($id: ID!, $guestUuid: String) {
    survey(id: $id, guestUuid: $guestUuid) {
      id
      isOwn
      isCoEdit
      isComplete
      status
      fromDateTime
      toDateTime
      autofillAvailable
      companion {
        name
      }
      cities {
        id
        name
        mainImageUrl(width: 440, height: 440)
        zone {
          id
          centerCoords
        }
      }
      createdAt
      itinerary {
        id
        destinations {
          id
          day
          type
          pos
          slotType
          memo
          accommType
          poi {
            placeId
            id
            poiType
            categories
            address
            city {
              zone {
                id
                name
              }
            }
            images {
              imageUrl(width: 100, height: 100)
              sourceUrl
            }
            ratings {
              provider
              rating
              count
            }
            name
            latitude
            longitude
            spentTime
            priceRange
            operatingHour
            zzimcarStayUrl
          }
        }
      }
      note {
        content
      }
      customName
      departurePoint {
        location
        latitude
        longitude
      }
    }
  }
`;

export const GetTransportsQuery = gql`
  query GetTransports($coords: [[Float]]) {
    transports(coords: $coords) {
      coords
      duration
      areBothInKorea
    }
  }
`;

export const SetItineraryOpenedMutation = gql`
  mutation SetItineraryOpened($surveyId: ID!, $guestUuid: String) {
    setItineraryOpened(surveyId: $surveyId, guestUuid: $guestUuid)
  }
`;

export const CompleteTripMutation = gql`
  mutation CompleteTrip($surveyId: ID!, $skip: Boolean!, $guestUuid: String) {
    completeTrip(surveyId: $surveyId, skip: $skip, guestUuid: $guestUuid) {
      id
      status
    }
  }
`;

export const BringSurveyMutation = gql`
  mutation BringSurvey($id: ID!, $guestUuid: String!) {
    bringSurvey(id: $id, guestUuid: $guestUuid) {
      id
    }
  }
`;

export const UpdateSurveyCustomNameMutation = gql`
  mutation UpdateSurveyCustomName($surveyId: ID!, $customName: String) {
    updateSurveyCustomName(id: $surveyId, customName: $customName) {
      id
      customName
    }
  }
`;

export const SaveNoteMutation = gql`
  mutation SaveNote($surveyId: ID!, $content: String!) {
    saveNote(surveyId: $surveyId, content: $content) {
      content
    }
  }
`;

export const DeleteSurveyMutation = gql`
  mutation DeleteSurvey($id: ID!, $guestUuid: String) {
    deleteSurvey(id: $id, guestUuid: $guestUuid)
  }
`;

export const GetListSurveyUsersQuery = gql`
  query GetListSurveyUsers($surveyId: ID!) {
    listSurveyUsers(surveyId: $surveyId) {
      id
      role
      user {
        id
        name
        email
        nickname
      }
    }
  }
`;

export const DeleteSurveyUserMutation = gql`
  mutation DeleteSurveyUser($surveyId: ID!, $surveyUserId: ID!) {
    deleteSurveyUser(surveyId: $surveyId, surveyUserId: $surveyUserId)
  }
`;

export const UpdateSurveyUserMutation = gql`
  mutation UpdateSurveyUser($surveyId: ID!, $surveyUserId: ID!, $role: CoEditRole!) {
    updateSurveyUser(surveyId: $surveyId, surveyUserId: $surveyUserId, role: $role)
  }
`;

export const CreateInviteCoEditLinkMutation = gql`
  mutation CreateInviteCoEditLink($surveyId: ID!, $role: CoEditRole!) {
    createInviteCoEditLink(surveyId: $surveyId, role: $role)
  }
`;

export const ValidInviteCoEditLinkMutation = gql`
  mutation ValidInviteCoEditLink($inviteId: ID!) {
    validInviteCoEditLink(inviteId: $inviteId) {
      tripId
      role
      fromDateTime
      toDateTime
      departureCity
      arrivalCity
      userName
      surveyName
    }
  }
`;

export const CreateSurveyUserMutation = gql`
  mutation CreateSurveyUser($inviteId: ID!) {
    createSurveyUser(inviteId: $inviteId) {
      id
    }
  }
`;

export const ConvertSearchResultFromPoiQuery = gql`
  query ConvertSearchResultFromPoi($poiId: ID!) {
    convertSearchResultFromPoi(poiId: $poiId) {
      name
      address
      placeId
      poiType
      zones {
        id
        name
        level
        isActive
        city {
          id
          name
          mainImageUrl(width: 48, height: 48)
          zone {
            id
            name
            level
            isActive
            city {
              id
              name
              mainImageUrl(width: 48, height: 48)
            }
          }
        }
        centerCoords
      }
    }
  }
`;

export const AddSlotMutation = gql`
  mutation addSlot($id: ID!, $slotInputs: [DestinationInput]) {
    updateSurvey(id: $id, destinationInputs: $slotInputs) {
      id
      day
      type
      pos
      slotType
      memo
      accommType
      poi {
        placeId
        id
        poiType
        categories
        address
        city {
          zone {
            id
            name
          }
        }
        images {
          imageUrl(width: 100, height: 100)
          sourceUrl
        }
        ratings {
          provider
          rating
          count
        }
        name
        latitude
        longitude
        spentTime
      }
    }
  }
`;

export const ModifySurveyDateMutation = gql`
  mutation ModifySurveyDate($surveyId: ID!, $fromDateTime: DateTime!, $toDateTime: DateTime!, $guestUuid: String) {
    modifySurveyDate(surveyId: $surveyId, fromDateTime: $fromDateTime, toDateTime: $toDateTime, guestUuid: $guestUuid) {
      id
      fromDateTime
      toDateTime
    }
  }
`;

export const GetAllSavedPoisQuery = gql`
  query GetAllSavedPois {
    allSavedPois {
      id
      originName
      placeId
      poiType
      latitude
      longitude
    }
  }
`;

export const SearchPoisUsingCoordsQuery = gql`
  query searchPoisUsingCoords($query: String!, $radius: Int, $center: CoordinatesInput) {
    searchPoi(query: $query, radius: $radius, center: $center) {
      placeId
      latitude
      longitude
      mainImageUrl
      name
      address
      poiType
      poi {
        placeId
        id
        poiType
        categories
        saved
        city {
          zone {
            name
          }
        }
        images {
          imageUrl(width: 100, height: 100)
          sourceUrl
        }
        ratings {
          provider
          rating
          count
        }
        name
        latitude
        longitude
        priceRange
        priceLevel
      }
    }
  }
`;

export const ReorderDestinationMutation = gql`
  mutation ReorderDestination($surveyId: ID!, $guestUuid: String, $reorderDestinationInput: ReorderDestinationInput!) {
    reorderDestination(surveyId: $surveyId, guestUuid: $guestUuid, reorderDestinationInput: $reorderDestinationInput) {
      id
      day
      type
      pos
      slotType
      memo
      accommType
      poi {
        placeId
        id
        poiType
        categories
        address
        city {
          zone {
            id
            name
          }
        }
        images {
          imageUrl(width: 100, height: 100)
          sourceUrl
        }
        ratings {
          provider
          rating
          count
        }
        name
        latitude
        longitude
        spentTime
      }
    }
  }
`;

export const ReorderAllDestinationsMutation = gql`
  mutation ReorderAllDestinations($surveyId: ID!, $guestUuid: String, $dayDestinations: [DayDestinationsInput!]!) {
    reorderAllDestinations(surveyId: $surveyId, guestUuid: $guestUuid, dayDestinations: $dayDestinations) {
      id
      day
      type
      pos
      slotType
      memo
      accommType
      poi {
        placeId
        id
        poiType
        categories
        address
        city {
          zone {
            id
            name
          }
        }
        images {
          imageUrl(width: 100, height: 100)
          sourceUrl
        }
        ratings {
          provider
          rating
          count
        }
        name
        latitude
        longitude
        spentTime
      }
    }
  }
`;

export const SaveDestinationMemoMutation = gql`
  mutation SaveDestinationMemo($surveyId: ID!, $guestUuid: String, $destinationInputs: [DestinationInput]) {
    updateSurvey(id: $surveyId, guestUuid: $guestUuid, destinationInputs: $destinationInputs) {
      id
      day
      type
      pos
      slotType
      memo
      accommType
      poi {
        placeId
        id
        poiType
        categories
        address
        city {
          zone {
            id
            name
          }
        }
        images {
          imageUrl(width: 100, height: 100)
          sourceUrl
        }
        ratings {
          provider
          rating
          count
        }
        name
        latitude
        longitude
        spentTime
      }
    }
  }
`;

export const RemoveSlotMutation = gql`
  mutation removeSlot($id: ID!, $guestUuid: String, $slotInputs: [DestinationInput]) {
    updateSurvey(id: $id, guestUuid: $guestUuid, destinationInputs: $slotInputs) {
      id
      day
      poi {
        placeId
        name
        categories
        ratings {
          provider
          rating
          count
        }
      }
    }
  }
`;

export const CopyTripMutation = gql`
  mutation CopyTrip($surveyId: ID!, $guestUuid: String, $name: String!) {
    copyTrip(surveyId: $surveyId, guestUuid: $guestUuid, name: $name) {
      id
    }
  }
`;

export const AddDestinationsMutation = gql`
  mutation AddDestinations(
    $surveyId: ID!
    $guestUuid: String
    $destinationInputs: [DestinationInput!]!
    $pos: Float!
    $increasingCount: Int!
  ) {
    addDestinations(
      surveyId: $surveyId
      guestUuid: $guestUuid
      destinationInputs: $destinationInputs
      pos: $pos
      increasingCount: $increasingCount
    ) {
      id
      day
      type
      pos
      slotType
      memo
      accommType
      poi {
        placeId
        id
        poiType
        categories
        address
        city {
          zone {
            id
            name
          }
        }
        images {
          imageUrl(width: 100, height: 100)
          sourceUrl
        }
        ratings {
          provider
          rating
          count
        }
        name
        latitude
        longitude
        spentTime
      }
    }
  }
`;

export const ReplaceSlotMutation = gql`
  mutation replaceSlot($id: ID!, $guestUuid: String, $slotInputs: [DestinationInput]) {
    updateSurvey(id: $id, guestUuid: $guestUuid, destinationInputs: $slotInputs) {
      id
      day
      type
      pos
      slotType
      memo
      accommType
      poi {
        placeId
        id
        poiType
        categories
        address
        city {
          zone {
            id
            name
          }
        }
        images {
          imageUrl(width: 100, height: 100)
          sourceUrl
        }
        ratings {
          provider
          rating
          count
        }
        name
        latitude
        longitude
        spentTime
      }
    }
  }
`;

export const ZzimProductListQuery = gql`
  query ZzimProductList($surveyId: ID!, $zzimProductInput: ZzimProductInput) {
    zzimProductList(surveyId: $surveyId, zzimProductInput: $zzimProductInput) {
      name
      minPrice
      tag
      redirectUrl
      startDate
      endDate
    }
    zzimProductListMo(surveyId: $surveyId, zzimProductInput: $zzimProductInput) {
      name
      minPrice
      tag
      redirectUrl
      startDate
      endDate
    }
  }
`;

export const ListTravelReviewQuery = gql`
  query ListTravelReview($offset: Int!, $limit: Int!) {
    listTravelReview(offset: $offset, limit: $limit) {
      hasNext
      edges {
        id
        title
        content
        userName
        surveyId
        category
        isOwner
        viewCount
        copyCount
        images
        createdAt
        updatedAt
        comments {
          id
          content
          userName
          createdAt
          updatedAt
          travelReviewId
          isOwner
          children {
            id
            content
            userName
            createdAt
            updatedAt
            travelReviewId
            isOwner
          }
        }
      }
    }
  }
`;

export const GetTravelReviewQuery = gql`
  query GetTravelReview($id: Int!) {
    getTravelReview(id: $id) {
      ... on TravelReview {
        id
        title
        content
        userName
        surveyId
        category
        isOwner
        viewCount
        copyCount
        images
        createdAt
        updatedAt
      }
      ... on DeleteReview {
        message
      }
    }
  }
`;

export const GetCommentsByTravelReviewIdQuery = gql`
  query GetCommentsByTravelReviewId($travelReviewId: Int!) {
    getCommentsByTravelReviewId(travelReviewId: $travelReviewId) {
      id
      content
      userName
      createdAt
      updatedAt
      travelReviewId
      isOwner
      isDeleted
      children {
        id
        content
        userName
        createdAt
        updatedAt
        travelReviewId
        isOwner
        isDeleted
        children {
          id
          content
          userName
          createdAt
          updatedAt
          travelReviewId
          isOwner
          isDeleted
        }
      }
    }
  }
`;

export const CreateTravelReviewCommentMutation = gql`
  mutation CreateTravelReviewComment($input: TravelReviewCommentInput) {
    createTravelReviewComment(input: $input) {
      id
      content
      userName
      createdAt
      updatedAt
      travelReviewId
      isOwner
    }
  }
`;

export const UpdateTravelReviewCommentMutation = gql`
  mutation UpdateTravelReviewComment($id: Int!, $input: TravelReviewCommentInput!) {
    updateTravelReviewComment(id: $id, input: $input) {
      id
      content
      userName
      createdAt
      updatedAt
      travelReviewId
      isOwner
    }
  }
`;

export const CreateTravelReviewMutation = gql`
  mutation CreateTravelReview($input: TravelReviewInput) {
    createTravelReview(input: $input) {
      id
      title
      content
      userName
      surveyId
      category
      isOwner
      createdAt
      updatedAt
    }
  }
`;

export const UpdateTravelReviewMutation = gql`
  mutation UpdateTravelReview($id: Int!, $input: TravelReviewInput!) {
    updateTravelReview(id: $id, input: $input) {
      id
      title
      content
      userName
      surveyId
      category
      isOwner
      createdAt
      updatedAt
    }
  }
`;

export const DeleteTravelReviewMutation = gql`
  mutation DeleteTravelReview($id: Int!) {
    deleteTravelReview(id: $id)
  }
`;

export const DeleteTravelReviewCommentMutation = gql`
  mutation DeleteTravelReviewComment($id: Int!) {
    deleteTravelReviewComment(id: $id)
  }
`;

export const ReportTravelReviewMutation = gql`
  mutation ReportTravelReview($id: Int!, $reason: String!) {
    reportTravelReview(id: $id, reason: $reason)
  }
`;

export const ReportTravelReviewCommentMutation = gql`
  mutation ReportTravelReviewComment($id: Int!, $travelReviewId: Int!, $reason: String!) {
    reportTravelReviewComment(id: $id, travelReviewId: $travelReviewId, reason: $reason)
  }
`;

export const InsertSurveyEntryPointMutation = gql`
  mutation InsertSurveyEntryPoint($entryPoint: String!) {
    insertSurveyEntryPoint(entryPoint: $entryPoint)
  }
`;

export const ListMainTravelCardsQuery = gql`
  query ListMainTravelCards {
    listMainTravelCards {
      title {
        normalText
        highlightText
      }
      travelCards {
        id
        name
        nameEng
        country
        mainImageUrl
        isVisible
      }
    }
  }
`;

export const ListTravelsCardsQuery = gql`
  query ListTravelCards {
    listTravelCards {
      id
      name
      nameEng
      country
      mainImageUrl
      isVisible
      continent
    }
  }
`;

export const GetTravelCardQuery = gql`
  query GetTravelCard($id: ID!) {
    getTravelCard(id: $id) {
      id
      name
      nameEng
      country
      mainImageUrl
      description
      flightTime
      isDirectFlight
      timeDifference
      costOfLiving
      currency
      exchangeRate
      recommendMonth
      zone {
        id
        name
        level
      }
      poiTitle {
        normalText
        highlightText
      }
    }
  }
`;

export const ListTravelCardPoiQuery = gql`
  query ListTravelCardPoi($travelCardId: ID!) {
    listTravelCardPoi(travelCardId: $travelCardId) {
      id
      name
      address
      thumbnail
    }
  }
`;

export const GetTravelCardPoiDetailQuery = gql`
  query GetTravelCardPoiDetail($poiId: ID!) {
    getTravelCardPoi(id: $poiId) {
      id
      name
      address
      poiType
      images
      description
      operatingHours {
        key
        value
      }
      tags
      thumbnail
      travelCardId
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

export const GetTravelCardCategoryQuery = gql`
  query GetTravelCardCategory {
    getTravelCardCategory
  }
`;

export const InsertCoexPromotionMutation = gql`
  mutation InsertCoexPromotion($name: String!, $mobile: String!) {
    insertCoexPromotion(name: $name, mobile: $mobile)
  }
`;

export const CreateZoneRequestMutation = gql`
  mutation createZoneRequest($zoneRequestInput: ZoneRequestInput!) {
    createZoneRequest(zoneRequestInput: $zoneRequestInput)
  }
`;

export const GetPoiImagesQuery = gql`
  query GetPoiImages($poiId: ID!) {
    poi(id: $poiId) {
      id
      images {
        imageUrl(width: 100, height: 100)
        sourceUrl
      }
    }
  }
`;
